import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  lineHeight: 1.5,
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
  letterSpacing: theme.typography.pxToRem(0.08),
}));

export const StyledActionButtonContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  alignItems: 'center',
  flexDirection: 'row',
  gap: theme.spacing(2.5),
  justifyContent: 'flex-end',
}));
